import React from "react";
import { Routes, Route } from "react-router-dom";
import FormsLibrary from "./FormLibrary";
import Folders from "./Folders";
const Docs = () => {
  return (
    <Routes>
      <Route path="folders/*" element={<Folders />} />
      <Route path="library/*" element={<FormsLibrary />} />
    </Routes>
  );
};

export default Docs;
